import styled from 'styled-components';
import Markdown from 'react-markdown';
import { useTranslation } from 'react-i18next';
import { AgentMessage } from './types';

const MessageContainer = styled.div<{ isUser: boolean }>`
  display: flex;
  justify-content: ${props => (props.isUser ? 'flex-end' : 'flex-start')};
  margin-bottom: 12px;
`;

const MessageBubble = styled.div<{ isUser: boolean }>`
  max-width: 70%;
  padding: 12px 16px;
  border-radius: 18px;
  background-color: ${props => (props.isUser ? '#007bff' : '#f1f1f1')};
  color: ${props => (props.isUser ? '#ffffff' : '#333333')};
  word-wrap: break-word;
  line-height: 1.4;
  ul {
    list-style-type: disc;
    padding-left: 20px;
  }
`;

const MessageHeader = styled.div`
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 4px;
  opacity: 0.8;
`;

interface ChatMessageProps {
  message: AgentMessage;
}

export function ChatMessage({ message }: ChatMessageProps) {
  const { t } = useTranslation('agents');
  const isUser = message.role === 'user';
  const content = message.i18nKey ? t(message.i18nKey) : message.content;
  const displayName = isUser
    ? t('campaignAssistant.chatMessage.userDisplayName')
    : t('campaignAssistant.chatMessage.agentDisplayName', { agentDisplayName: t('campaignAssistant.agentName') });

  return (
    <MessageContainer isUser={isUser}>
      <MessageBubble isUser={isUser}>
        <MessageHeader>{displayName}</MessageHeader>
        <Markdown>{content}</Markdown>
      </MessageBubble>
    </MessageContainer>
  );
}
